<div class="max-w-md mx-auto mt-12 p-8 bg-white rounded-2xl shadow-lg animate-fade-in space-y-6 relative">
    <div *ngIf="loading()" class="absolute inset-0 bg-white/60 backdrop-blur-sm z-10 flex items-center justify-center">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <h2 class="text-3xl font-bold text-center text-gray-700">Iniciar sesión</h2>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email">
        <mat-error *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
          Email inválido
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Contraseña</mat-label>
        <input matInput type="password" formControlName="password">
        <mat-error *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
          Mínimo 6 caracteres
        </mat-error>
      </mat-form-field>

      <mat-checkbox formControlName="recordarSesion">Recordarme</mat-checkbox>

      
      <button
      type="button"
      (click)="abrirDialogRecuperacion()"
      class="block text-sm text-blue-600 hover:underline text-right mt-2 bg-transparent border-none cursor-pointer"
    >
      ¿Olvidaste tu contraseña?
    </button>
    

      

      <button mat-raised-button
        color="primary"
        class="w-full py-2 font-semibold tracking-wide"
        type="submit"
        [disabled]="form.invalid || loading()"
      >Ingresar</button>

    </form>

    <app-social-login-buttons (success)="onLoginExitoso()"></app-social-login-buttons>
    <p class="text-center text-sm mt-4">¿No tenés una cuenta? <a routerLink="/register" class="text-blue-500 hover:text-blue-700">Registrate</a></p>
    <p *ngIf="error()" class="text-red-600 text-center text-sm mt-2">
      {{ error() }}
    </p>
  </div>
